import * as EmailValidator from "email-validator";
import { emailMessages } from "./EmailEntry";

export const emailValidator = {
    validateRules(newText, match) {
        const errors = [];
        if (match && newText.trim() === match.trim()) {
            errors.push({ message: emailMessages.emailsMustNotMatch });
        }
        return errors;
    },
    validateFormat: (email) => {
      const errors = [];
      // Skip validation if email is empty.
      if (!email.trim()) {
        return errors;
      }
      const emailValid = EmailValidator.validate(email);

      if (!emailValid) {
        errors.push({ message: emailMessages.emailMustBeValid });
      }
      return errors;
    }
  };